/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_BackInputs */

const en_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

const nl_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga terug`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Go_BackInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const go_back = /** @type {((inputs?: Go_BackInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_BackInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_go_back(inputs)
	return en_go_back(inputs)
});